import { createReducer } from '../utils/helpers';
import { ActionTypes } from '../utils/constants';

export const testDriveState = {
  data: null,
  isLoading: false,
  error: false,
  rsvp: {
    isLoading: false,
    data: null,
    error: false,
  },
  confirmation: {
    requestSent: false,
    isSending: false,
    error: false,
    data: null,
    // data: {
    //   id: 36157,
    //   ultimaActualizacion: null,
    //   infoAdicional: '',
    //   hora: '',
    //   fechaCita: '',
    //   idVehiculo: 'ML20XXUJGLXD5M4 - 2021',
    //   sucursal: 'test',
    //   urlResumen: '',
    //   cliente: {
    //     nombre: 'gabriel',
    //     apellidos: 'sanchez',
    //     profesion: 'vagabundo',
    //     tipoId: 'FISICO',
    //     identificacion: '206350719',
    //     email: 'test@test.com',
    //     telefono: '68988767',
    //     direccion: 'test',
    //   },
    //   datosCarro: {
    //     codigo: 'ML20XXUJGLXD5M4',
    //     codigoAnio: 'ML20XXUJGLXD5M4 - 2021',
    //     marca: 'MITSUBISHI',
    //     marcaFiltro: null,
    //     modelo: 'L200',
    //     quickbaseCodigoRecorId: null,
    //     anio: '2021',
    //     version: 'NEW L200 GLX 4X4 2.4L D/C TDICR M/T',
    //     precioPublico: '39900.00',
    //     primaSeguroBasica: null,
    //     descripcionSeguro: '',
    //     vehiculosDisponibles: '2',
    //     tipo: null,
    //     transmision: 'MANUAL',
    //     descripcion: null,
    //     imagenPequena:
    //       'https://veinsacr.quickbase.com/up/bim84vjwq/a/r1398/e214/v0/L200-T_276x145px-05-86898c-min.png',
    //     imagenGrande:
    //       'https://veinsacr.quickbase.com/up/bim84vjwq/a/r1398/e222/v0/L200-T_540x340px-05-min.png',
    //     imagenUrlLocal: null,
    //     precioSeguroBasico: '0',
    //     precioSeguroPlus: null,
    //     destacado: '0',
    //     nuevo: null,
    //     combustible: 'DIESEL',
    //     traccion: '4X4',
    //     pasajeros: '5',
    //     marchas: 'MT6',
    //     cilindrada: '2.4',
    //     nombreAmigable: 'L200 GLX 4x4 Manual',
    //     descLarga:
    //       'El L200 ha sido diseñado para conseguir la mayor estabilidad y tracción. Su robusta estructura contribuye a su sólida conducción y su carrocería está contorneada aerodinámicamente para obtener un estable rendimiento sobre el asfalto. La fiable tracción a las cuatro ruedas se combina con una avanzada suspensión para permitirle estar en contacto en todo momento con la superficie, de manera que pueda obtener un firme control. La confortablemente cabina del L200 ofrece un espacio líder de su clase que le permite relajarse y poder estirar las piernas cómodamente. Los asientos de alta calidad mejorados, incluyendo los asientos delanteros con un nuevo diseño, intensifican el placer de la conducción para los ocupantes. La seguridad en caso de colisión ha sido mejorada significativamente gracias a la carrocería RISE de Mitsubishi (Reinforced Impact Safety Evolution), la cual absorbe eficientemente la energía y mantiene un alto nivel de integridad de la cabina en caso de una colisión.',
    //     descCorta:
    //       'Transmisión de 6 Velocidades | Frenos ABS/EBD | Ventanas Eléctricas | Cierre Central | Ganchos para Sujeción de Carga',
    //     caracteristicasVersion:
    //       '<ul>\n\t<li>Luces de halógeno</li>\n\t<li>Llantas 205R16</li>\n\t<li>Aire acondicionado</li>\n\t<li>Ventanas eléctricas</li>\n\t<li>Cierre central</li>\n\t<li>Volante con ajuste de altura</li>\n\t<li>Radio CD MP3 con puerto USB</li>\n\t<li>2 Air Bags</li>\n\t<li>Frenos ABS/EBD</li>\n\t<li>Motor diésel, 4 cilindros de 2.400cc, 16 Válvulas, CRDI</li>\n\t<li>Potencia: 134hp</li>\n\t<li>Torque: 324Nm</li>\n\t<li>Tracción 4x4  de 2 relaciones (4x4 High & 4x4 Low)</li>\n\t<li>Transmisión Manual de 6 Velocidades</li>\n\t<li>Capacidad de Carga 1015kg</li>\n</ul>',
    //     fotoWeb: null,
    //     precioOferta: '38900.00',
    //     descuento: null,
    //     descripcionDescuento: null,
    //     slogan: '¡Pura malacrianza!',
    //     cuota24Meses: '172.75',
    //     colors: [],
    //     anios: [],
    //     versiones: [],
    //     accessories: [],
    //     insurances: [],
    //     maintenances: [],
    //     descuentoPromocion: '1000.00',
    //     logoUrl: null,
    //     colorCode: null,
    //     segurosSeleccionados: null,
    //     accesoriosSeleccionados: null,
    //     mantenimientosSeleccionados: null,
    //     precioCalculado: null,
    //     cuota: null,
    //     caracteristicasExteriores: null,
    //     caracteristicasInterior: null,
    //     caracteristicasSeguridad: null,
    //     caracteristicasCapacidad: null,
    //     precioFinal: null,
    //   },
    // },
  },
};

export default {
  testDrive: createReducer(testDriveState, {
    [ActionTypes.FETCH_TEST_DRIVE_RSVP_REQUEST](state) {
      return {
        ...state,
        rsvp: {
          isLoading: true,
          data: null,
          error: false,
        },
      }
    },
    [ActionTypes.FETCH_TEST_DRIVE_RSVP_SUCCESS](state, action) {
      const { info } = action.payload;
      return {
        ...state,
        rsvp: {
          isLoading: false,
          data: info,
          error: false
        },
      }
    },
    [ActionTypes.FETCH_TEST_DRIVE_RSVP_FAILURE](state) {
      return {
        ...state,
        rsvp: {
          isLoading: false,
          data: null,
          error: true
        },
      }
    },
    [ActionTypes.FETCH_TEST_DRIVE_INFO_REQUEST](state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    [ActionTypes.FETCH_TEST_DRIVE_INFO_SUCCESS](state, action) {
      return {
        ...state,
        isLoading: false,
        data: action.payload.info,
      };
    },
    [ActionTypes.FETCH_TEST_DRIVE_INFO_FAILURE](state, action) {
      return {
        ...state,
        isLoading: false,
      };
    },
    [ActionTypes.REQUEST_TEST_DRIVE_REQUEST](state) {
      return {
        ...state,
        confirmation: {
          ...state.confirmation,
          isSending: true,
        },
      };
    },
    [ActionTypes.REQUEST_TEST_DRIVE_SUCCESS](state, action) {
      return {
        ...state,
        confirmation: {
          ...state.confirmation,
          requestSent: true,
          isSending: false,
          data: action.payload.data,
        },
      };
    },
    [ActionTypes.REQUEST_TEST_DRIVE_FAILURE](state) {
      return {
        ...state,
        confirmation: {
          ...state.confirmation,
          isSending: false,
        },
      };
    },
    [ActionTypes.REQUEST_TEST_DRIVE_RESET](state) {
      return testDriveState;
    },
  }),
};
